import * as React from "react";
const SvgFiRrLightCeiling = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-light-ceiling_svg__a)">
      <path
        fill="#062147"
        d="M23.763 14.458c-1.6-4.58-6.025-7.985-10.763-8.411V1a1 1 0 1 0-2 0v5.047C6.262 6.474 1.837 9.878.237 14.458a4.19 4.19 0 0 0 .534 3.801A4.09 4.09 0 0 0 4.142 20H8c0 2.206 1.794 4 4 4s4-1.794 4-4h3.857a4.09 4.09 0 0 0 3.371-1.741 4.19 4.19 0 0 0 .534-3.8zM12 22c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2m9.598-4.898a2.11 2.11 0 0 1-1.74.898H4.143c-.7 0-1.335-.328-1.74-.898a2.16 2.16 0 0 1-.276-1.984C3.567 10.994 7.72 8 12.001 8s8.434 2.994 9.874 7.118a2.16 2.16 0 0 1-.276 1.983z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-light-ceiling_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLightCeiling;
